import type { ComponentType } from "react"

export interface PageModule {
  default: ComponentType<Record<string, unknown>>
}

/** Resolver für `createInertiaApp`; `pages` stammt aus `import.meta.glob`. */
export async function resolvePage(
  pages: Record<string, () => Promise<PageModule>>,
  name: string,
) {
  const page = await pages[`../pages/${name}.tsx`]?.()
  if (!page) throw new Error(`Page not found: ${name}`)

  return page.default
}
